import React from 'react';
import Layout from '../../components/Layout';
import NotFound from '../not-found/NotFound';
import LegalPage from './LegalPage';
import { getLegalPage } from './content';

// One action serves every hand-built legal/business page. The matching path is registered (before the
// admin catch-all /:pageUrl) in userRoutes, so these premium pages take precedence over admin content.
function action(context) {
  const pathname = (context && (context.pathname || context.path)) || '';
  const page = getLegalPage(pathname);

  if (!page) {
    return {
      title: 'Not Found',
      component: <Layout><NotFound title="Not Found" /></Layout>,
      status: 404,
    };
  }

  return {
    title: page.metaTitle || page.title,
    description: page.metaDescription,
    component: (
      <Layout>
        <LegalPage page={page} />
      </Layout>
    ),
  };
}

export default action;
